module.exports = __webpack_public_path__ + "static/media/pencilGrey.6bd5aad4.svg";